import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { TrainingLogByDayFromHttp, TrainingLogByYearFromHttp } from '../models/stats.model';


@Injectable({
  providedIn: 'root',
})
export class StatsApi {
  constructor(private readonly http: HttpClient) { }

  getStatsByDays(startDate: Date, endDate: Date, sportType: string): Observable<TrainingLogByDayFromHttp> {
    // Allways add one day for the api take into account the end day
    const apiRealMaxDate = dayjs(endDate).add(1, 'day').format('YYYY-MM-DD');
    const params = new HttpParams()
      // .set('user_id', userId)
      .set('sportType', sportType ?? 'all')
      .set('minDate', dayjs(startDate).format('YYYY-MM-DD'))
      .set('maxDate', apiRealMaxDate)
      .set('includeFreeRide', 'true')
      .set('includeWorkout', 'true')
      .set('includeGpsOnly', 'true');

    return this.http.get<TrainingLogByDayFromHttp>(environment.api.dashboard.myTrainingLog, { params });
  }

  getAllStatsByYear(sportType: string): Observable<TrainingLogByYearFromHttp> {
    const params = new HttpParams()
      // .set('user_id', userId)
      .set('sportType', sportType ?? 'all')
      .set('includeFreeRide', 'true')
      .set('includeWorkout', 'true')
      .set('includeGpsOnly', 'true');

    return this.http.get<TrainingLogByYearFromHttp>(environment.api.dashboard.myTrainingLog, { params });
  }
}
